import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InputField from './InputField';
import Button from './button';
import Heading from './heading';
import { forgetPass } from './../../../actions/userActions';
import ShowHidePassword from './hideShowPassword';
import APP from 'app';
const { Utils } = APP, { translateText } = Utils;
class ChangePassword extends Component {
    state = {
        userData: {},
        showError: false,
        fieldName: '',
        msgType: '',
        otpContent: false,
        showPassword: false,
        showConfirmPassword: false
    }

    onChangeHandler = (value, context) => {
        this.setState({
            userData: {
                ...this.state.userData,
                [context]: value
            }
        })
    }

    onSubmitHandler = () => {
        const { userData = {} } = this.state;
        this.props.dispatch(forgetPass(userData));

    }

    onKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.onSubmitHandler();
        }
    }

    onBlur = () => {
        if (this.state.errMsg) {
            this.validate();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { otpJson = {}, forgetSuccess = false } = nextProps;
        const { otpToken = {} } = otpJson;
        let { requestId = '', key = '', userName = '' } = otpToken;
        userName = userName || key;
        this.setState({
            userData: {
                ...this.state.userData,
                userName,
                requestId
            }
        });
        if (forgetSuccess) {
            this.setState({
                otpContent: !this.state.otpContent
            })
        }
    }

    backHandler = () => {
        if (typeof this.props.showForgetHandler === 'function') {
            this.props.showForgetHandler();
        }
    }

    showHidePassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    showConfirmPassword = () => {
        this.setState({
            showConfirmPassword: !this.state.showConfirmPassword
        })
    }

    render() {
        const { userData = {}, fieldName = '', msgType = '', otpContent = false, showPassword = false, showConfirmPassword = false } = this.state;
        return (
            <Fragment>
                {!otpContent ?
                    <Fragment>
                        <Heading
                            title={'Change Password'}
                        />
                        <p className="b2cform__field--otpsent">{translateText('OTPSentMsg', 'B2CLogin')}</p>
                        <InputField
                            type='text'
                            placeholder={translateText('enterOTP', 'B2CLogin')}
                            context='otp'
                            onChangeHandler={this.onChangeHandler}
                            name='otp'
                            value={userData['otp']}
                            handleKeyDown={this.onKeyDown}
                            onBlur={this.onBlur}
                            errorText={fieldName.includes('otp') ? msgType : ''}
                        />
                        <div className="b2c__loginwrap--showhidepassword">
                            <InputField
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder={translateText('enterNewPassword', 'B2CLogin')}
                                context='newPassword'
                                onChangeHandler={this.onChangeHandler}
                                name='newPassword'
                                value={userData['newPassword']}
                                handleKeyDown={this.onKeyDown}
                                onBlur={this.onBlur}
                                errorText={fieldName.includes('newpassword') ? msgType : ''}
                            />
                            <ShowHidePassword
                                showPassword={showConfirmPassword}
                                showHidePassword={this.showConfirmPassword}
                            />
                        </div>
                        <div className="b2c__loginwrap--showhidepassword">
                            <InputField
                                type={showPassword ? 'text' : 'password'}
                                placeholder={translateText('confirmPassword', 'B2CLogin')}
                                context='reTypePassword'
                                onChangeHandler={this.onChangeHandler}
                                name='reTypePassword'
                                value={userData['reTypePassword']}
                                handleKeyDown={this.onKeyDown}
                                onBlur={this.onBlur}
                                errorText={fieldName.includes('retypepassword') ? msgType : ''}
                            />
                            <ShowHidePassword
                                showPassword={showPassword}
                                showHidePassword={this.showHidePassword}
                            />
                        </div>
                        <Button
                            type='button'
                            onSubmitHandler={this.onSubmitHandler}
                            displayLabel={translateText('submitBtn', 'B2CLogin')}
                        />
                    </Fragment> :
                    <Fragment>
                        <Fragment>
                            {otpContent ?
                                <p className="b2cform__field--registered">
                                    {translateText('passwordResetSuccessfully', 'B2CLogin')}
                                    <span onClick={this.backHandler} className="b2cform__field--clickhere"> {translateText('clickHere', 'B2CLogin')}</span> {translateText('toLogin', 'B2CLogin')}</p> : ''}
                        </Fragment>
                    </Fragment>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    const { userinfos = {} } = state;
    const { otpJson = {}, forgetSuccess = false } = userinfos;
    return {
        otpJson,
        forgetSuccess
    }
};

const mapDispatchToProps = dispatch => {
    let actions = bindActionCreators({
        forgetPass
    });
    return { actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);